/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Assign_Track_BInputs */



/**
* | output |
* | --- |
* | "Assign Track B" |
*
* @param {Shortcut_Keys_Name_Assign_Track_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_assign_track_b = /** @type {((inputs?: Shortcut_Keys_Name_Assign_Track_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Assign_Track_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer la piste B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gleis B zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna la traccia B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить дорожку B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar vía B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配轨道 B")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックBを割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक बी असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir a faixa B")
	return /** @type {LocalizedString} */ ("Assign Track B")
});